import { makeStyles, Text } from "@fluentui/react-components";
import TitleText from "../../../components/titleText/TitleText";
import IPageSteps, { IStep } from "../../../models/page/pageComponents/IPageSteps";
import { dolphinTokens } from "../../../utils/Theme";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        padding: "0 2rem",
        maxWidth: "1200px",
        margin: "0 auto",
        alignItems: "center",
    },
    stepsGrid: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "2rem",
        marginTop: "1rem",
    },
    step: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: "1.5rem",
    },
    numberBadge: {
        minWidth: "3rem",
        height: "3rem",
        borderRadius: "50%",
        backgroundColor: dolphinTokens.colorLightBlue,
        color: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "1.2rem",
        fontWeight: "700",
        flexShrink: "0",
    },
    stepContent: {
        display: "flex",
        flexDirection: "column",
        gap: "0.4rem",
    },
    stepTitle: {
        fontWeight: "700",
        fontSize: "1.1rem",
        color: dolphinTokens.colorDarkBlue,
    },
    stepDescription: {
        color: "#666666",
        fontSize: "1rem",
        lineHeight: "1.7",
    },
});

const StepItem = ({ step, index }: { step: IStep; index: number }) => {
    const styles = useStyles();
    return (
        <div className={styles.step}>
            <div className={styles.numberBadge}>{index + 1}</div>
            <div className={styles.stepContent}>
                <Text className={styles.stepTitle}>{step.title}</Text>
                <Text className={styles.stepDescription}>{step.description}</Text>
            </div>
        </div>
    );
};

export default function Steps(props: IPageSteps) {
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <TitleText
                title={props.title}
                titleHighlightedWords={props.titleHighlightedWords}
                subtitle={props.subtitle}
                alignment="center"
                width="100%"
            />
            <div className={styles.stepsGrid}>
                {props.steps?.map((step, index) => (
                    <StepItem key={index} step={step} index={index} />
                ))}
            </div>
        </div>
    );
}
